// src/data/pricingData.js

export const PRICING_DATA = {
    aviation: {
        id: 'aviation',
        name: 'Pilot & ATCs',
        description: 'Master clear and concise communication in aviation.',
        price: 40.00,       
        monthly: 600.00,    
        groupPrice: 20.00,  
        groupMonthly: 300.00, 
        lessons: 180,       
        lessonsPerMonth: 15,
        schedule: 'Flexible scheduling',
        groupSchedule: 'Fixed schedule with others',
        stripePriceIds: {
            one_one_monthly: 'price_1S9EjBKAY8PM72prRVIzGa3B',
            one_one_annual: 'price_1S9EjBKAY8PM72prpELw2JgV',
            group_monthly: 'price_1S9EmdKAY8PM72proAWWBWZV',
            group_annual: 'price_1S9Eq5KAY8PM72prNo1myYP9'
        }
    },
    legal: {
        id: 'legal',
        name: 'Legal Professionals',
        description: 'Improve legal writing and courtroom communication.',
        price: 38.00,
        monthly: 400.00,
        groupPrice: 19.00,
        groupMonthly: 200.00,
        lessons: 158,
        lessonsPerMonth: 13,
        schedule: 'Flexible scheduling',
        groupSchedule: 'Fixed schedule with others',
        stripePriceIds: {
            one_one_monthly: 'price_1S9S2SKAY8PM72prVmOG3TDf',
            one_one_annual: 'price_1S9QF8KAY8PM72prnVKLMGDw',
            group_monthly: 'price_1S9SCpKAY8PM72prJFyR8dDi',
            group_annual: 'price_1S9S9pKAY8PM72prJuGB4l2R'
        }
    },
    medical: {
        id: 'medical',
        name: 'Medical Professionals',
        description: 'Patient communication and medical reporting.',
        price: 35.00,
        monthly: 430.00,
        groupPrice: 17.50,
        groupMonthly: 215.00,
        lessons: 150,
        lessonsPerMonth: 12,
        schedule: 'Flexible scheduling',
        groupSchedule: 'Fixed schedule with others',
        stripePriceIds: {
            one_one_monthly: 'price_1S9SGjKAY8PM72prqoXlByr6',
            one_one_annual: 'price_1S9SErKAY8PM72pra3klqu7m',
            group_monthly: 'price_1S9SKWKAY8PM72prMnfgQ0UR',
            group_annual: 'price_1S9SIxKAY8PM72pr8OQyJSB8'
        }
    },
    logistics: {
        id: 'logistics',
        name: 'Logistics Coordinator',
        description: 'Freight, supply chain, and global trade operations.',
        price: 35.00,
        monthly: 430.00,
        groupPrice: 17.50,
        groupMonthly: 215.00,
        lessons: 150,
        lessonsPerMonth: 12,
        schedule: 'Flexible scheduling',
        groupSchedule: 'Fixed schedule with others',
        stripePriceIds: {
            one_one_monthly: 'price_1S9SOaKAY8PM72preqD1krGe',
            one_one_annual: 'price_1S9SNGKAY8PM72pr3P8DDlD7',
            group_monthly: 'price_1S9SRcKAY8PM72prJY0wwCiD',
            group_annual: 'price_1S9SQMKAY8PM72prflcvyg7V'
        }
    },
    young_genius: {
        id: 'young_genius',
        name: 'Young Geniuses (12-17)',
        description: 'Creative pathway for young minds to explore engineering and design.',
        price: 35.00,       // Teacher: $17.50
        monthly: 430.00,
        groupPrice: 17.50,  // Teacher: $8.75 per student
        groupMonthly: 215.00,
        lessons: 150,
        lessonsPerMonth: 12,
        schedule: 'Flexible scheduling',
        groupSchedule: 'Fixed schedule with others',
        stripePriceIds: {
            one_one_monthly: 'price_placeholder_yg_mo', // Update with real ID when ready
            one_one_annual: 'price_placeholder_yg_yr',
            group_monthly: 'price_placeholder_yg_grp_mo',
            group_annual: 'price_placeholder_yg_grp_yr'
        }
    },
    banking: {
        id: 'banking',
        name: 'Banking Professionals',
        description: 'Finance, client relations, and market analysis.',
        price: 35.00,
        monthly: 430.00,
        groupPrice: 17.50,
        groupMonthly: 215.00,
        lessons: 150,
        lessonsPerMonth: 12,
        schedule: 'Flexible scheduling',
        groupSchedule: 'Fixed schedule with others',
        stripePriceIds: {
            one_one_monthly: 'price_1S9SVBKAY8PM72prqRnOn54N',
            one_one_annual: 'price_1S9STpKAY8PM72prgBdRUmgz',
            group_monthly: 'price_1S9SZ0KAY8PM72prQMfL1jml',
            group_annual: 'price_1S9SXgKAY8PM72prEgSwwSKF'
        }
    },
    mining: {
        id: 'mining',
        name: 'Mining Engineers',
        description: 'Site safety, meetings, and technical reporting.',
        price: 35.00,
        monthly: 430.00,
        groupPrice: 17.50,
        groupMonthly: 215.00,
        lessons: 150,
        lessonsPerMonth: 12,
        schedule: 'Flexible scheduling',
        groupSchedule: 'Fixed schedule with others',
        stripePriceIds: {
            one_one_monthly: 'price_1S9SbZKAY8PM72pr9Dyj1SgC',
            one_one_annual: 'price_1S9SaKKAY8PM72prQLQfySvV',
            group_monthly: 'price_1S9SeGKAY8PM72prwTsaljW8',
            group_annual: 'price_1S9SdCKAY8PM72prjJ5kGjVM'
        }
    },
    oilgas: {
        id: 'oilgas',
        name: 'Oil & Gas Professionals',
        description: 'Drilling, safety, and field operations.',
        price: 35.00,
        monthly: 430.00,
        groupPrice: 17.50,
        groupMonthly: 215.00,
        lessons: 150,
        lessonsPerMonth: 12,
        schedule: 'Flexible scheduling',
        groupSchedule: 'Fixed schedule with others',
        stripePriceIds: {
            one_one_monthly: 'price_1S9X7HKAY8PM72prZLSomS0g',
            one_one_annual: 'price_1S9X58KAY8PM72prsXS4bjtQ',
            group_monthly: 'price_1S9XE2KAY8PM72prmDubK1PB',
            group_annual: 'price_1S9XChKAY8PM72prcmctGXfZ'
        }
    },
    hotel: {
        id: 'hotel',
        name: 'Hotel & Hospitality',
        description: 'Front office, revenue management, and guest relations.',
        price: 35.00,
        monthly: 430.00,
        groupPrice: 17.50,
        groupMonthly: 215.00,
        lessons: 148,
        lessonsPerMonth: 12,
        schedule: 'Flexible scheduling',
        groupSchedule: 'Fixed schedule with others',
        stripePriceIds: {
            one_one_monthly: 'price_1S9Sh3KAY8PM72pru0Bpet5e',
            one_one_annual: 'price_1S9SfqKAY8PM72prXlQuqHWG',
            group_monthly: 'price_1S9SkDKAY8PM72pr6Bbi8GGu',
            group_annual: 'price_1S9Sj9KAY8PM72prfUo7Dmv9'
        }
    },
    aesthetician: {
        id: 'aesthetician',
        name: 'Aestheticians',
        description: 'Client consultation and service delivery.',
        price: 32.00,
        monthly: 320.00,
        groupPrice: 16.00,
        groupMonthly: 160.00,
        lessons: 120,
        lessonsPerMonth: 10,
        schedule: 'Flexible scheduling',
        groupSchedule: 'Fixed schedule with others',
        stripePriceIds: {
            one_one_monthly: 'price_1S9XHhKAY8PM72pr0QpAOTTv',
            one_one_annual: 'price_1S9XFkKAY8PM72prrAedQV1c',
            group_monthly: 'price_1S9XL5KAY8PM72prptIVQYu3',
            group_annual: 'price_1S9XJqKAY8PM72prO8rmnS87'
        }
    },
    cabin: {
        id: 'cabin',
        name: 'Cabin Crew Professionals',
        description: 'In-flight service and emergency procedures.',
        price: 32.00,
        monthly: 320.00,
        groupPrice: 16.00,
        groupMonthly: 160.00,
        lessons: 120,
        lessonsPerMonth: 10,
        schedule: 'Flexible scheduling',
        groupSchedule: 'Fixed schedule with others',
        stripePriceIds: {
            one_one_monthly: 'price_1S9XOtKAY8PM72prIJAdQDXX',
            one_one_annual: 'price_1S9XN7KAY8PM72prBFRjGxyd',
            group_monthly: 'price_1S9XRZKAY8PM72pr84LTbwL4',
            group_annual: 'price_1S9XQVKAY8PM72pr7zbFFPFx'
        }
    }
  };
  
  export const SPECIAL_PLANS_DATA = [
    {
        id: 'dream_achiever',
        name: '🌟 Dream Achiever Plan',
        description: 'Goal-setting and leadership skills for ambitious professionals.',
        priceRange: '$200 - $500+/month',
        cta: 'Apply Now',
        href: '/contact'
    }
  ];
  
  export const findCourseData = (courseId) => {
    return Object.values(PRICING_DATA).find(c => c.id === courseId);
  };